<template>
  <div class="StarRating">
    <div :class="['StarRating-rating', 'StarRating--'+ size]">
      <div class="StarRating-stars">
        <span
          v-for="(star, index) in maxStars"
          :key="index"
          :class="[star<=stars ? 'fas fa-star' : 'far fa-star']"
          @mouseover="mouseOver(index)"
          @mouseleave="mouseOut"
          @click="handler(index)"
        />
      </div>
      <span class="StarRating-stats">
        {{ roundNumber(tempValue, 1) }}/10
      </span>
    </div>
    <div
      v-if="polarAdjectives !== null"
      class="StarRating-help"
    >
      <span class="StarRating-helper">
        <span class="StarRating-figure">1 Star</span> = {{ polarAdjectives.bad }}
      </span>
      <span class="StarRating-helper">
        <span class="StarRating-figure">10 Star</span> = {{ polarAdjectives.good }}
      </span>
    </div>
    <error-message
      :errors="errors"
      :is-blurred="isBlurred"
      :manual-validate="true"
    />
  </div>
</template>

<script>
import { roundNumber } from '@/filters';
import errorMessage from './partials/error-message.vue';

export default {
  components: { errorMessage },
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    manualValidate: {
      type: Boolean,
      default: false,
    },
    isBlurred: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'regular',
    },
    polarAdjectives: {
      type: Object,
      default: null,
    },
  },
  emits: ['input', 'update:modelValue'],
  data() {
    return {
      tempValue: 0,
      maxStars: 10,
      roundNumber,
    };
  },
  computed: {
    stars() {
      return Math.round(this.tempValue);
    },
  },

  watch: {
    modelValue: {
      immediate: true,
      handler() {
        this.tempValue = this.modelValue || 0;
      },
    },
  },

  methods: {
    mouseOver(value) {
      if (this.readOnly) {
        return;
      }
      this.tempValue = value + 1;
    },
    mouseOut() {
      if (this.readOnly) {
        return;
      }
      this.tempValue = this.modelValue === null ? 0 : this.modelValue;
    },
    handler(value) {
      if (this.readOnly) {
        return;
      }
      this.$emit('input', value + 1);
      this.$emit('update:modelValue', value + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
  // abstract
  @import "../../../scss/abstracts/abstracts";

  .StarRating {
    display: inline-block;
  }

  .StarRating-rating {
    display: flex;
    align-items: center;
    /*flex-wrap: wrap;*/
  }

  .StarRating-help {
    display: flex;
    color: color('grey');
    justify-content: space-between;
    margin-top: spacing(sm);
    font-size: rem(14px);
  }

  .StarRating-helper {
    display: inline-block;
    max-width: calc(50% - #{spacing()});
    &:last-of-type{
      margin-left: spacing();
    }
  }

  .StarRating-figure {
    //background-color: color('orange');
    //padding: spacing(xs);
    //color: color('white');
    //border-radius:radius();
    //font-family: salsbury,Helvetica Neue,Arial,sans-serif;
  }

  .StarRating-stats {
    background: color('yellow');
    color: color('white');
    font-weight: $font-weight-heavy;
    display: inline-block;
    font-size: 1rem;
    vertical-align: middle;
    text-align: center;
    /*margin: spacing() auto spacing(xs) auto;*/
    padding: 0 spacing(xs);
    border-radius: radius();
    /*font-size: 25px;*/
    @include respond-to(md){
      font-size: inherit;
      margin: 0 0 0 spacing(xs);
    }
  }

  .StarRating--large {
    .StarRating-stats {
      line-height: 35px;
      height: 35px;
    }
    //  font-size: calc([minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width])));
    font-size: calc(23px + (45 - 23) * ((100vw - 320px) / (599 - 320)));
    @include customMediaQuery(min-width, 599px) {
      font-size: 25px;
    }
  }

  .StarRating-stars {
    height: 37px;
    display: inline-block;
    width: 100%;
    display: flex;
    font-size: 1rem;
    align-items: center;
    @include customMediaQuery(min-width, 599px) {
      width: auto;
    }
  }
</style>
<!--
Loop stars
Hover star get value
click state
return newvalue
update star rating
parent - button enabled
-->
<!--

<template>
  <div class="rating-stars">
    <div class="review&#45;&#45;score">
      <abbr :title="title" class="star-rating-representation">
        <span v-for="(star, index) in maxStars" :key="index"
              :class="[star<=stars ? 'fas fa-star' : 'icon-star-outline']"></span>
      </abbr>
    </div>
    <span class="score&#45;&#45;value"><abbr :title="title">{{rating}}/{{maxStars}}</abbr></span>
  </div>
</template>
<script>
  export default {
    name: 'ReviewRatingStars',
    props: {
      rating: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        maxStars: 10,
      };
    },
    computed: {
      title() {
        return `${this.rating}/${this.maxStars} Star Review Rating.`;
      },
      stars() {
        return Math.round(this.rating);
      },
    },
    methods: {},
  };
</script>
<style scoped>
  .rating-stars{
    display: flex;
    align-items: center;
  }
  .star-rating-representation{
    display: flex;
    align-items: center;
  }
  .review&#45;&#45;score{
    height: auto;
    vertical-align: middle;
  }
</style>

Collapse
Message Input

Message @Dom Lear

About this conversation

Dom Lear
Time zone 11:34 AM local time-->
